import { action, makeObservable, observable } from "mobx";
import { BaseStore } from "stores/BaseStore";
import type { IRootStore } from "stores/RootStore";
import { AcxStore } from "stores/RootStore";
import { AuthStore } from "stores/AuthStore";
import AcxDataGridStore from "components/UI/AcxDataGrid/AcxDataGridStore";

@AcxStore
export class DataHandlerStore extends BaseStore {
    readonly dataGridStore: AcxDataGridStore;
    readonly authStore: AuthStore;

    @observable activeStep: number = 0;
    @observable isFieldModalOpen: boolean = false;
    @observable isManageFieldsModalOpen: boolean = false;
    @observable isDiscardModalOpen: boolean = false;
    @observable newFieldName: string = "";
    @observable selectedType: string = "DataSource";
    @observable isIndexed: boolean = false;
    @observable hasUnsavedChanges: boolean = false;
    @observable canEdit: boolean = false;

    constructor(private rootStore: IRootStore) {
        super("DataHandlerStore");
        makeObservable(this);

        this.dataGridStore = new AcxDataGridStore(
            "DataHandlerStore",
            "OrganizationDatasource",
        );
        this.authStore = rootStore.getStore(AuthStore);

        this.dataGridStore.hideFilter = true;
        this.dataGridStore.hideVertIcon = true;
        this.dataGridStore.disableRowSelectionOnClick = true;
        this.dataGridStore.disableLocalConfig = true;
        this.dataGridStore.rows = [];
        this.canEdit = this.authStore.canUserEdit("Data Sources");
    }

    setIsDiscardModalOpen = (isOpen: boolean) => {
        this.isDiscardModalOpen = isOpen;
    };

    @action
    setSelectedType = (type: string) => {
        this.selectedType = type;
    };

    @action
    setIsFieldModalOpen = (isOpen: boolean) => {
        this.isFieldModalOpen = isOpen;
    };

    @action
    setNewFieldName = (name: string) => {
        this.newFieldName = name;
    };

    @action
    discardChanges = () => {
        this.isDiscardModalOpen = false;
        this.hasUnsavedChanges = false;
        this.activeStep = 0;
    };

    @action
    setActiveStep = (step: number) => {
        // If trying to go to step 0 with unsaved changes, show modal
        if (step === 0 && this.hasUnsavedChanges) {
            this.isDiscardModalOpen = true;
            return;
        }

        this.activeStep = step;
    };

    @action
    setIsIndexed = (isIndexed: boolean) => {
        this.isIndexed = isIndexed;
    };

    @action
    setIsManageFieldsModalOpen = (isOpen: boolean) => {
        this.isManageFieldsModalOpen = isOpen;
    };

    @action
    setHasUnsavedChanges = (hasUnsavedChanges: boolean) => {
        this.hasUnsavedChanges = hasUnsavedChanges;
    };
}
